// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"3fc00370","381":"a1012b2e","393":"c141b271","724":"bb93187a","758":"74e14311"}[chunkId] + ".chunk.js";
};